import { fallbackLocale } from '@manager/config/locale-config';
import en from '@manager/locales/en.json';
import { getPersistedLanguage } from '@manager/utils/user-settings-utils';
import type { App } from 'vue';
import { createI18n } from 'vue-i18n';

const locale = getPersistedLanguage();

export type ILanguages =
  | 'en'
  | 'de'
  | 'fr'
  | 'pl'
  | 'pt'
  | 'el'
  | 'cs'
  | 'sl'
  | 'fi'
  | 'ca';
type IMessageSchema = typeof en;

export const i18n = createI18n<[IMessageSchema], ILanguages>({
  legacy: false,
  silentTranslationWarn: true,
  locale,
  fallbackLocale,
  missingWarn: false,
  globalInjection: true,
});

export function i18nInit(app: App) {
  app.use(i18n);
}
